import React from 'react';
import { Scales, Lock } from '@phosphor-icons/react';

export const SharedPasswordGate = ({ password, setPassword, onSubmit, error }) => (
  <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center" data-testid="shared-password-page">
    <div className="bg-white border border-[#E5E7EB] rounded-lg p-8 max-w-md w-full mx-4">
      <div className="flex items-center gap-2 mb-6">
        <Scales weight="duotone" className="w-8 h-8 text-[#002FA7]" />
        <span className="font-outfit text-2xl font-bold text-[#09090B]">ClarityCase AI</span>
      </div>
      <Lock size={40} className="text-[#002FA7] mb-4" />
      <h2 className="font-outfit text-xl font-bold text-[#09090B] mb-2">Password Required</h2>
      <p className="text-sm text-[#6B7280] font-ibm mb-6">This case report is password protected.</p>
      {error && <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-md text-sm font-ibm">{error}</div>}
      <form onSubmit={onSubmit} className="space-y-4">
        <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter password"
          className="w-full px-4 py-3 border border-[#E5E7EB] rounded-md font-ibm focus:outline-none focus:ring-2 focus:ring-[#002FA7]" data-testid="shared-password-input" />
        <button type="submit" className="w-full py-3 bg-[#002FA7] text-white font-ibm font-semibold rounded-md hover:bg-[#00237D] transition-all" data-testid="shared-password-submit">
          View Report
        </button>
      </form>
    </div>
  </div>
);
